/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";

export type AddDeploymentPackageForm = {
  /**
   * The name of the package.
   */
  name: string;
  /**
   * The version of the package.
   */
  version?: string | undefined;
};

/** @internal */
export type AddDeploymentPackageForm$Outbound = {
  name: string;
  version?: string | undefined;
};

/** @internal */
export const AddDeploymentPackageForm$outboundSchema: z.ZodMiniType<
  AddDeploymentPackageForm$Outbound,
  AddDeploymentPackageForm
> = z.object({
  name: z.string(),
  version: z.optional(z.string()),
});

export function addDeploymentPackageFormToJSON(
  addDeploymentPackageForm: AddDeploymentPackageForm,
): string {
  return JSON.stringify(
    AddDeploymentPackageForm$outboundSchema.parse(addDeploymentPackageForm),
  );
}
